export const environment = {
  production: false,
  webUrl: 'https://dev-app.seemylegacy.com',
  apiUrl: 'https://sml-api-dev-dsddhdducjfnbscv.eastus-01.azurewebsites.net/',
  authPath: 'https://apigateway.sml.com/auth/token',
  googleAPI:'AIzaSyDDDZbuHM-69n-mGonMR2C_3GAXCl7dXZs',
  stripePublishableKey: 'pk_test_51PJIvWP5SR9ZDLAg50sN1WQJCJ9ebvX5z42DdnG2IwsA7S1jGeAHGHGe8XXfhCjU1WUb9sOaQF9h96puZkN8O9Mi00LQV7IM5i',
  surveyJsKey: 'MGY5MTZlMTctYzk2My00OTQ0LTk4ZDktMDQ2NDZmNzY0NjM0OzE9MjAyNi0wNi0wNQ==',
  appVersion: `1.0.0`,
  name: 'dev',
  hideColumns:true,
  showDisbursements: true,
  // true = redesigned campaign overview; false = the previous campaign screen.
  useCampaignOverviewV2: true,
  aiReviewCommunity:'1008',
  // Stock photo library. `provider` selects the adapter; the matching key must
  // be filled in for that provider. Keys here ship in the browser bundle.
 stockImage: {
    provider: 'pexels',
    pexelsApiKey: '5W0rFXb2QEeppjCoad5Fa1gRIMEnX06ddU3rkYkNrTOo8e3yn5VVtRmh',
  },
  allowedEmailsForTemplateActions: [
    'varun.saraswat+88@taazaa.com',
    'sandeepn@taazaa.com',
    'akashsangal006@yopmail.com',
    'varun.saraswat+7a@taazaa.com',
    "akash.sangal@taazaa.com"
  ]
};
